import React from 'react'
import { Select } from 'antd'

export const statusFilterMethod = (filter, row) => {
  const activeArray = ['Active']
  const inactiveArray = ['Inactive']

  if (filter.value === 'all') {
    return true
  }
  if (filter.value === 'active') {
    return activeArray.includes(row[filter.id])
  }
  if (filter.value === 'inactive') {
    return inactiveArray.includes(row[filter.id])
  }
  return filter.value === true ? activeArray.includes(row[filter.id]) : inactiveArray.includes(row[filter.id])
}

function StatusFilter({ onChange, filter }) {
  return (
    <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'Active'}>
      <Select.Option value={'active'}>Active</Select.Option>
      <Select.Option value={'inactive'}>Inactive</Select.Option>
      <Select.Option value="all">All</Select.Option>
    </Select>
  )
}

StatusFilter.propTypes = {}
StatusFilter.defaultProps = {}

export default StatusFilter
